(function () {
  var section = document.querySelector('[data-config-product]');
  if (!section) return;
  var root = section.closest('.pdpc') || document;

  var data;
  try {
    data = JSON.parse(section.textContent);
  } catch (e) {
    return;
  }

  var minCansMixed = parseInt(data.minCansMixed, 10) || 4;
  // First-order sub discount override. When the toggle is ON, the theme stops
  // trusting Skio's selling-plan allocation price and instead computes sub
  // price = compare × (1 - pct/100). Lets you move the first-order discount
  // to a Shopify automatic product discount (Skio only handles recurring %)
  // while keeping the marketing "39% OFF" in the UI.
  var firstOrderSubOverride = data.firstOrderSubOverrideEnabled === true;
  var firstOrderSubPct = parseFloat(data.firstOrderSubPct) || 0;
  var flavors = Array.isArray(data.flavors) ? data.flavors : [];
  var galleryMixed = Array.isArray(data.gallery) ? data.gallery : [];
  var gallery5Pack = Array.isArray(data.gallery5Pack) ? data.gallery5Pack : [];

  function activeGallery() {
    if (state.mode === 'single5' && gallery5Pack.length) return gallery5Pack;
    return galleryMixed;
  }

  function emptyCounts() {
    return { 'ginger-lime': 0, 'cucumber-citrus': 0, 'cool-mint': 0, 'watermelon': 0 };
  }

  // Each mode owns its own count map so switching tabs never bleeds an
  // exploratory selection from the other view into the active one.
  var state = {
    mode: 'mixed',
    plan: 'subscribe',
    countsMixed: emptyCounts(),
    countsSingle5: emptyCounts()
  };

  function counts() {
    return state.mode === 'single5' ? state.countsSingle5 : state.countsMixed;
  }

  var els = {
    flavorList: root.querySelector('[data-flavor-list]'),
    modeBtns: root.querySelectorAll('[data-mode]'),
    modeCaption: root.querySelector('[data-mode-caption]'),
    planBtns: root.querySelectorAll('[data-plan]'),
    subPrice: root.querySelector('[data-sub-price]'),
    otPrice: root.querySelector('[data-ot-price]'),
    fullPrice: root.querySelector('[data-full-price]'),
    fullPrice2: root.querySelector('[data-full-price-2]'),
    subPerCan: root.querySelector('[data-sub-percan]'),
    otPerCan: root.querySelector('[data-ot-percan]'),
    perCan: root.querySelector('[data-percan]'),
    perCan2: root.querySelector('[data-percan-2]'),
    otPerCanWas: root.querySelector('[data-ot-percan-was]'),
    subPct: root.querySelector('[data-sub-pct]'),
    otPct: root.querySelector('[data-ot-pct]'),
    subPct2: root.querySelector('[data-sub-pct-2]'),
    otPct2: root.querySelector('[data-ot-pct-2]'),
    cta: root.querySelector('[data-cta]'),
    ctaPrice: root.querySelector('[data-cta-price]'),
    ctaDefault: root.querySelector('[data-cta-default]'),
    ctaWarning: root.querySelector('[data-cta-warning]'),
    planGroup: root.querySelector('[data-plan-group]'),
    perksSub: root.querySelector('[data-perks-sub]'),
    perksOnetime: root.querySelector('[data-perks-onetime]'),
    footSub: root.querySelector('[data-foot-sub]'),
    footSubDot: root.querySelector('[data-foot-sub-dot]'),
    trust: root.querySelector('[data-trust]'),
    vsSavings: root.querySelector('[data-vs-savings]'),
    switchSub: root.querySelector('[data-switch-sub]'),
    galleryMain: root.querySelector('[data-pdpc-main]'),
    thumbs: root.querySelector('[data-pdpc-thumbs]')
  };

  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  function variantFor(f) {
    return state.mode === 'single5' ? f.fivePack : f.single;
  }

  // In mixed mode, 5+ cans of one flavor are billed as 5-packs + singles
  // (auto-optimized so the customer gets the 5-pack price tier).
  function flavorBreakdown(f) {
    var n = counts()[f.id] || 0;
    if (n <= 0) return { fivePacks: 0, singles: 0 };
    if (state.mode === 'single5') return { fivePacks: n, singles: 0 };
    return { fivePacks: Math.floor(n / 5), singles: n % 5 };
  }

  // Mirror Shopify's per-line discount math exactly: floor((variant_cents * pct) / 100).
  // Used by the override to make PDP totals reconcile with checkout to the penny.
  function lineSubPrice(variantCents) {
    if (!firstOrderSubOverride || firstOrderSubPct <= 0) return null;
    var discount = Math.floor(variantCents * firstOrderSubPct / 100);
    return variantCents - discount;
  }

  function totals() {
    var oneTimeCents = 0;
    var subscribeCents = 0;
    var compareCents = 0;
    var cans = 0;
    flavors.forEach(function (f) {
      var bd = flavorBreakdown(f);
      if (bd.fivePacks > 0 && f.fivePack) {
        var fv = f.fivePack;
        var fPrice = fv.price || 0;
        var fSubAlloc = fv.subscribePrice != null ? fv.subscribePrice : fPrice;
        var fSubOverride = lineSubPrice(fPrice);
        var fSub = fSubOverride != null ? fSubOverride : fSubAlloc;
        var fCompare = fv.compareAtPrice != null ? fv.compareAtPrice : fPrice;
        oneTimeCents += bd.fivePacks * fPrice;
        subscribeCents += bd.fivePacks * fSub;
        compareCents += bd.fivePacks * fCompare;
        cans += bd.fivePacks * (fv.cans || 5);
      }
      if (bd.singles > 0 && f.single) {
        var sv = f.single;
        var sPrice = sv.price || 0;
        var sSubAlloc = sv.subscribePrice != null ? sv.subscribePrice : sPrice;
        var sSubOverride = lineSubPrice(sPrice);
        var sSub = sSubOverride != null ? sSubOverride : sSubAlloc;
        var sCompare = sv.compareAtPrice != null ? sv.compareAtPrice : sPrice;
        oneTimeCents += bd.singles * sPrice;
        subscribeCents += bd.singles * sSub;
        compareCents += bd.singles * sCompare;
        cans += bd.singles * (sv.cans || 1);
      }
    });
    return { oneTimeCents: oneTimeCents, subscribeCents: subscribeCents, compareCents: compareCents, cans: cans };
  }

  function totalUnits() {
    var t = 0;
    var c = counts();
    flavors.forEach(function (f) { t += c[f.id] || 0; });
    return t;
  }

  // Stepper shows the unit count directly. Mixed mode: 1 unit = 1 can.
  // Single5 mode: 1 unit = one 5-pack — count of 1 displays as "1", not "5".
  function displayCans(f) {
    return counts()[f.id] || 0;
  }

  function renderFlavors() {
    if (!els.flavorList) return;
    var isSingle = state.mode === 'single5';
    var c = counts();
    var html = flavors.map(function (f) {
      var n = c[f.id] || 0;
      var isOn = n > 0;
      var img = isSingle ? f.stack : f.lid;
      var cls = 'bb__flavor' + (isOn ? ' is-on' : '');
      var lidCls = 'bb__lid' + (isSingle ? ' bb__lid--stack' : '');
      // Both modes: dec only blocked when this row is at 0. Per-flavor
      // floor is 0; the global minimum is enforced at the CTA.
      var dec = n === 0;
      return (
        '<div class="' + cls + '" style="--bb-accent: ' + f.accent + '" data-flavor="' + f.id + '">' +
          '<span class="' + lidCls + '"><img src="' + (img || '') + '" alt="" loading="lazy"></span>' +
          '<span class="bb__fname">' + f.name + '</span>' +
          '<span class="bb__stepper">' +
            '<button type="button" data-dec aria-label="less"' + (dec ? ' disabled' : '') + '>−</button>' +
            '<span class="bb__count">' + displayCans(f) + '</span>' +
            '<button type="button" data-inc aria-label="more">+</button>' +
          '</span>' +
        '</div>'
      );
    }).join('');
    els.flavorList.innerHTML = html;
  }

  function updateFlavorCounts() {
    if (!els.flavorList) return;
    var c = counts();
    flavors.forEach(function (f) {
      var card = els.flavorList.querySelector('[data-flavor="' + f.id + '"]');
      if (!card) return;
      var n = c[f.id] || 0;
      card.classList.toggle('is-on', n > 0);
      var countEl = card.querySelector('.bb__count');
      if (countEl) countEl.textContent = displayCans(f);
      var decBtn = card.querySelector('[data-dec]');
      if (decBtn) decBtn.disabled = n === 0;
    });
  }

  function pctOff(was, now) {
    if (!was || was <= 0) return 0;
    if (now >= was) return 0;
    return Math.round((1 - now / was) * 100);
  }

  function renderPrices() {
    var t = totals();
    var oneTime = t.oneTimeCents;
    var subscribe = t.subscribeCents;
    var compare = t.compareCents;
    var cans = t.cans;

    // Subscribe is already overridden per-line in totals() via lineSubPrice
    // when firstOrderSubOverride is on — mirrors Shopify's checkout math.

    var subPerCan = cans > 0 ? subscribe / cans : 0;
    var otPerCan = cans > 0 ? oneTime / cans : 0;
    var regPerCan = cans > 0 ? (compare > oneTime ? compare : oneTime) / cans : 0;

    // Both "% OFF" badges baseline against the variant's compare-at price
    // (Shopify MSRP). Sub badge = sub vs compare. One-Time badge = one-time
    // vs compare. Numbers are pulled live from variant data — never hardcoded.
    if (els.subPrice)   els.subPrice.textContent   = fmt(subscribe);
    if (els.otPrice)    els.otPrice.textContent    = fmt(oneTime);
    if (els.fullPrice)  els.fullPrice.textContent  = fmt(compare > oneTime ? compare : oneTime);
    if (els.fullPrice2) els.fullPrice2.textContent = fmt(compare > oneTime ? compare : oneTime);
    if (els.subPerCan)  els.subPerCan.textContent  = fmt(subPerCan);
    if (els.otPerCan)   els.otPerCan.textContent   = fmt(otPerCan);
    if (els.perCan)     els.perCan.textContent     = fmt(regPerCan);
    if (els.perCan2)    els.perCan2.textContent    = fmt(regPerCan);

    var subPct = pctOff(compare, subscribe);
    var otPct = pctOff(compare, oneTime);
    if (els.subPct)  els.subPct.textContent  = subPct + '% OFF';
    if (els.subPct2) els.subPct2.textContent = subPct + '% off';
    if (els.otPct) {
      els.otPct.textContent = otPct + '% OFF';
      els.otPct.hidden = otPct <= 0;
    }
    if (els.otPct2) els.otPct2.textContent = otPct + '% off';

    var displayPrice = state.plan === 'subscribe' ? subscribe : oneTime;
    if (els.ctaPrice) els.ctaPrice.textContent = fmt(displayPrice);
    if (els.vsSavings) els.vsSavings.textContent = fmt(oneTime - subscribe);

    renderPerks();
    renderCTAState();
  }

  // Plan picker + perks stay hidden until the customer has selected enough.
  // Mixed mode: requires `minCansMixed` total. 5-pack mode: any 1+ unit.
  // Below threshold, the CTA's "Add N more cans" / "Pick a flavor" warning
  // is the only call to action — no pricing decision to make yet.
  function planGateOpen() {
    if (state.mode === 'mixed') return totalUnits() >= minCansMixed;
    return totalUnits() >= 1;
  }

  function renderPerks() {
    var open = planGateOpen();
    var isSub = state.plan === 'subscribe';
    if (els.planGroup) els.planGroup.hidden = !open;
    if (els.perksSub) els.perksSub.hidden = !open || !isSub;
    if (els.perksOnetime) els.perksOnetime.hidden = !open || isSub;
    if (els.trust) els.trust.hidden = !open || isSub;
    // "Skip or cancel anytime" only applies to subscription — hide on one-time
    if (els.footSub) els.footSub.hidden = !isSub;
    if (els.footSubDot) els.footSubDot.hidden = !isSub;
  }

  function renderCTAState() {
    if (!els.cta) return;
    var units = totalUnits();
    var t = totals();
    var disabled = false;
    var warning = '';

    if (state.mode === 'mixed' && units < minCansMixed) {
      var needed = minCansMixed - units;
      warning = 'Add ' + needed + ' more ' + (needed === 1 ? 'can' : 'cans');
      disabled = true;
    } else if (state.mode === 'single5' && units < 1) {
      warning = 'Pick a flavor to continue';
      disabled = true;
    } else if (t.oneTimeCents <= 0) {
      disabled = true;
    }

    els.cta.disabled = disabled;
    if (els.ctaDefault) els.ctaDefault.hidden = !!warning;
    if (els.ctaWarning) {
      els.ctaWarning.hidden = !warning;
      if (warning) els.ctaWarning.textContent = warning;
    }
  }

  function renderModes() {
    els.modeBtns.forEach(function (btn) {
      var isActive = btn.getAttribute('data-mode') === state.mode;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function renderPlans() {
    els.planBtns.forEach(function (btn) {
      var isActive = btn.getAttribute('data-plan') === state.plan;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function setMainImage(img) {
    if (!els.galleryMain || !img) return;
    els.galleryMain.removeAttribute('srcset');
    els.galleryMain.src = img.src;
    els.galleryMain.alt = img.alt || '';
  }

  function renderGallery() {
    if (!els.thumbs) return;
    var imgs = activeGallery();
    if (imgs.length) setMainImage(imgs[0]);
    if (imgs.length < 2) {
      els.thumbs.innerHTML = '';
      return;
    }
    var html = imgs.map(function (img, i) {
      return '<button type="button" data-thumb="' + i + '" class="' + (i === 0 ? 'is-active' : '') + '"><img src="' + img.thumb + '" alt="' + (img.alt || '') + '" loading="lazy"></button>';
    }).join('');
    els.thumbs.innerHTML = html;
  }

  function bindThumbs() {
    if (!els.thumbs) return;
    els.thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-thumb]');
      if (!btn) return;
      var i = parseInt(btn.getAttribute('data-thumb'), 10);
      var imgs = activeGallery();
      var img = imgs[i];
      if (!img) return;
      els.thumbs.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      setMainImage(img);
    });
  }

  els.modeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mode = btn.getAttribute('data-mode');
      if (state.mode === mode) return;
      // Each mode keeps its own counts (state.countsMixed / countsSingle5),
      // so flipping tabs is a pure view change — no cross-mode bleed.
      state.mode = mode;
      renderModes();
      renderFlavors();
      renderGallery();
      renderPrices();
    });
  });

  els.planBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.plan = btn.getAttribute('data-plan');
      renderPlans();
      renderPrices();
    });
  });

  if (els.switchSub) {
    els.switchSub.addEventListener('click', function () {
      state.plan = 'subscribe';
      renderPlans();
      renderPrices();
    });
  }

  if (els.flavorList) {
    els.flavorList.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      var card = btn.closest('[data-flavor]');
      if (!card) return;
      var fid = card.getAttribute('data-flavor');
      var c = counts();
      var current = c[fid] || 0;
      if (btn.hasAttribute('data-inc')) {
        c[fid] = current + 1;
      } else if (btn.hasAttribute('data-dec')) {
        if (current <= 0) return;
        c[fid] = current - 1;
      }
      updateFlavorCounts();
      renderPrices();
    });
  }

  if (els.cta) {
    els.cta.addEventListener('click', function () {
      addToCart();
    });
  }

  function skioGroupToken() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'skio-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function addToCart() {
    var isSub = state.plan === 'subscribe';
    var items = [];
    var subscribedItems = [];
    function pushItem(v, qty) {
      if (!v || !v.variantId || qty <= 0) return;
      var item = { id: v.variantId, quantity: qty };
      if (v.cans) {
        item.properties = item.properties || {};
        item.properties._cans = String(v.cans);
      }
      if (isSub && v.sellingPlanId) {
        item.selling_plan = v.sellingPlanId;
        subscribedItems.push(item);
      }
      items.push(item);
    }
    flavors.forEach(function (f) {
      var bd = flavorBreakdown(f);
      if (bd.fivePacks > 0) pushItem(f.fivePack, bd.fivePacks);
      if (bd.singles > 0) pushItem(f.single, bd.singles);
    });
    if (!items.length) return;

    if (isSub && subscribedItems.length > 1) {
      var token = skioGroupToken();
      subscribedItems.forEach(function (item) {
        item.properties = item.properties || {};
        item.properties._skio_group_token = token;
      });
    }

    els.cta.disabled = true;
    var originalHTML = els.cta.innerHTML;
    els.cta.innerHTML = 'Adding…';
    // Suppress cart→configurator sync until ATC finishes; otherwise the
    // clearManagedFromCart step would wipe the active counts mid-flight.
    if (typeof window.__pdpcAtcGuard === 'function') window.__pdpcAtcGuard(true);

    // The cart is treated as a mirror of the configurator: before we add the
    // new selection, zero out any existing line items whose variant the
    // configurator manages (all flavor singles + 5-packs). Otherwise a
    // customer who returns from checkout via the back button and edits their
    // selection ends up with both the old and new items in the cart.
    var managedVariantIds = {};
    flavors.forEach(function (f) {
      if (f.single && f.single.variantId) managedVariantIds[f.single.variantId] = true;
      if (f.fivePack && f.fivePack.variantId) managedVariantIds[f.fivePack.variantId] = true;
    });

    function clearManagedFromCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var cartItems = (cart && cart.items) || [];
          var hasManaged = false;
          for (var i = 0; i < cartItems.length; i++) {
            if (managedVariantIds[cartItems[i].variant_id]) { hasManaged = true; break; }
          }
          if (!hasManaged) return null;
          // Array form of `updates` maps 1:1 to cart.items by position, so we
          // can zero managed lines while preserving any unrelated items.
          var updates = cartItems.map(function (it) {
            return managedVariantIds[it.variant_id] ? 0 : it.quantity;
          });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        });
    }

    clearManagedFromCart()
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        els.cta.disabled = false;
        els.cta.innerHTML = originalHTML;
        if (typeof window.__pdpcAtcGuard === 'function') window.__pdpcAtcGuard(false);
        // Resync since cart may be partially mutated (cleared but not re-added).
        if (typeof window.__pdpcSyncFromCart === 'function') window.__pdpcSyncFromCart();
      });
  }

  renderModes();
  renderPlans();
  renderFlavors();
  renderGallery();
  bindThumbs();
  renderPrices();

  // ---- Cart → configurator sync ---------------------------------------------
  // The configurator is treated as a live mirror of the customer's pouch cart.
  // Without this, removing items in the cart drawer (or returning from
  // checkout) leaves the steppers showing a stale selection and re-clicking
  // ATC double-counts items.
  var variantLookup = {};
  flavors.forEach(function (f) {
    if (f.single && f.single.variantId) {
      variantLookup[f.single.variantId] = { flavorId: f.id, isFivePack: false };
    }
    if (f.fivePack && f.fivePack.variantId) {
      variantLookup[f.fivePack.variantId] = { flavorId: f.id, isFivePack: true };
    }
  });

  function applyCartState(cart) {
    var items = (cart && cart.items) || [];
    var cansByFlavor = {};
    var fivePacksByFlavor = {};
    var singlesByFlavor = {};
    var hasManaged = false;
    var subCount = 0;
    var otCount = 0;
    flavors.forEach(function (f) {
      cansByFlavor[f.id] = 0;
      fivePacksByFlavor[f.id] = 0;
      singlesByFlavor[f.id] = 0;
    });
    items.forEach(function (it) {
      var meta = variantLookup[it.variant_id];
      if (!meta) return;
      hasManaged = true;
      var qty = it.quantity || 0;
      if (meta.isFivePack) {
        fivePacksByFlavor[meta.flavorId] += qty;
        cansByFlavor[meta.flavorId] += qty * 5;
      } else {
        singlesByFlavor[meta.flavorId] += qty;
        cansByFlavor[meta.flavorId] += qty;
      }
      if (it.selling_plan_allocation || it.selling_plan) subCount += qty;
      else otCount += qty;
    });

    if (!hasManaged) {
      // Cart has no pouches — clear both modes (cart is source of truth, no
      // exploratory state should outlive an empty cart).
      state.countsMixed = emptyCounts();
      state.countsSingle5 = emptyCounts();
    } else {
      // Decide mode: 5-pack mode only fits "one flavor, only 5-packs". Anything
      // else falls back to mixed so every cart shape is representable. The
      // OTHER mode is always wiped so a user clicking the inactive tab sees a
      // fresh "explore" canvas, not stale data from a previous session.
      var flavorsWithSingles = 0;
      var flavorsWithAny = 0;
      var lastFlavorWith5Pack = null;
      flavors.forEach(function (f) {
        if (singlesByFlavor[f.id] > 0) flavorsWithSingles++;
        if (cansByFlavor[f.id] > 0) {
          flavorsWithAny++;
          if (fivePacksByFlavor[f.id] > 0) lastFlavorWith5Pack = f.id;
        }
      });
      var onlyFivePacksOneFlavor = (flavorsWithSingles === 0 && flavorsWithAny === 1 && lastFlavorWith5Pack);
      if (onlyFivePacksOneFlavor) {
        state.mode = 'single5';
        state.countsSingle5 = emptyCounts();
        state.countsSingle5[lastFlavorWith5Pack] = fivePacksByFlavor[lastFlavorWith5Pack];
        state.countsMixed = emptyCounts();
      } else {
        state.mode = 'mixed';
        state.countsMixed = cansByFlavor;
        state.countsSingle5 = emptyCounts();
      }

      if (subCount > 0 && otCount === 0) state.plan = 'subscribe';
      else if (otCount > 0 && subCount === 0) state.plan = 'onetime';
      // mixed sub/onetime in cart: leave state.plan alone
    }

    renderModes();
    renderPlans();
    renderFlavors();
    renderGallery();
    renderPrices();
  }

  // Guard so we don't re-sync while an ATC is in-flight (clearManagedFromCart
  // mutates the cart and would otherwise wipe the very items we're adding).
  var atcInFlight = false;
  function syncFromCart() {
    if (atcInFlight) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(applyCartState)
      .catch(function () { /* network issue: keep current UI */ });
  }
  // Re-export so addToCart can flip the guard / force a resync on failure.
  window.__pdpcAtcGuard = function (on) { atcInFlight = !!on; };
  window.__pdpcSyncFromCart = syncFromCart;

  // Initial sync (handles "back from checkout" case and any stale tab).
  syncFromCart();

  document.addEventListener('zalt:cart-updated', function (e) {
    if (atcInFlight) return;
    applyCartState(e.detail);
  });

  // Snapshot the CTA's idle markup so we can restore it after a BFCache
  // restore (browser back from checkout). Without this, the button stays
  // stuck on "Adding…" because JS state is preserved by the cache.
  var ctaIdleHTML = els.cta ? els.cta.innerHTML : null;
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && els.cta && ctaIdleHTML != null) {
      els.cta.disabled = false;
      els.cta.innerHTML = ctaIdleHTML;
      // The inner spans were detached when addToCart did `innerHTML = 'Adding…'`,
      // so the cached references in `els` point at orphaned nodes. Re-query.
      els.ctaDefault = els.cta.querySelector('[data-cta-default]') || els.ctaDefault;
      els.ctaPrice = els.cta.querySelector('[data-cta-price]') || els.ctaPrice;
      els.ctaWarning = els.cta.querySelector('[data-cta-warning]') || els.ctaWarning;
      atcInFlight = false;
    }
    // Always re-sync from cart on pageshow — covers the bfcache return-from-
    // checkout case where the cart may have changed since this tab was active.
    syncFromCart();
  });
})();
